export const massUnits  = ["g", "dag", "kg", "pinch"] as const
export const lengthUnits = ["mm", "cm", "dm", "m"] as const
export const currencyUnits = ["euro", "dollar", "pound"] as const
